import { assertNotEmpty } from '@festina-life/core'
import { Alert } from '@festina-life/ui/feedback'
import { useTranslate } from '@festina-life/ui/hooks'

import { TemplateFieldsTable } from '../../../components/templateFieldsTable/TemplateFieldsTable'
import { TemplateFieldsTableContextProvider } from '../../../components/templateFieldsTable/templateFieldsTableContext'
import { useLayoutContext } from '../../../context/layoutContext'
import { useTemplateContext } from '../../../context/templateContext'
import { useTemplateHierarchy } from '../../../uiModels/versionInfo/useTemplateHierarchy'
import { GeneralTemplateOperationErrors } from './GeneralTemplateOperationErrors'

export const TemplateVersionViewer = () => {
  const translate = useTranslate()
  const { templateVersion } = useTemplateContext()
  const {
    preferences: {
      templates: { isFlattened },
    },
  } = useLayoutContext()

  assertNotEmpty(templateVersion)

  const hierarychy = useTemplateHierarchy({
    forTemplate: templateVersion?.versionInfo,
    withReplacements: true,
  })

  return (
    <TemplateFieldsTableContextProvider
      value={{
        isTableInsideDetailsPanel: false,
        selectedSubFieldPath: undefined,
      }}
    >
      {isFlattened && !templateVersion.isFlattened && (
        <Alert
          severity="error"
          title={translate('templateViewer.flatteningError', {
            missingTemplates: hierarychy
              .filter(
                (hierarychyVersion) =>
                  hierarychyVersion.isMissing ||
                  hierarychyVersion.isHideVersion,
              )
              .map((hierarchyVersion) => hierarchyVersion.identifier)
              .join(','),
          })}
        />
      )}
      <GeneralTemplateOperationErrors />
      <TemplateFieldsTable
        level={0}
        parent={templateVersion}
        fields={templateVersion.fields}
        declaredFunctions={templateVersion.declaredFunctions}
        dynamicFunctions={templateVersion.dynamicFunctions}
        isCollapsible
      />
    </TemplateFieldsTableContextProvider>
  )
}
